[
  {
    "standardDeductionGroup": 0,
    "filingStatus": "Head of Household",
    "year": 2025,
    "value": 23625
  },
  {
    "standardDeductionGroup": 1,
    "filingStatus": "Head of Household",
    "year": 2025,
    "value": 25625
  },
  {
    "standardDeductionGroup": 2,
    "filingStatus": "Head of Household",
    "year": 2025,
    "value": 27625
  },
  {
    "standardDeductionGroup": 0,
    "filingStatus": "Married Filing Jointly",
    "year": 2025,
    "value": 31500
  },
  {
    "standardDeductionGroup": 1,
    "filingStatus": "Married Filing Jointly",
    "year": 2025,
    "value": 33100
  },
  {
    "standardDeductionGroup": 2,
    "filingStatus": "Married Filing Jointly",
    "year": 2025,
    "value": 34700
  },
  {
    "standardDeductionGroup": 3,
    "filingStatus": "Married Filing Jointly",
    "year": 2025,
    "value": 36300
  },
  {
    "standardDeductionGroup": 4,
    "filingStatus": "Married Filing Jointly",
    "year": 2025,
    "value": 37900
  },
  {
    "standardDeductionGroup": 0,
    "filingStatus": "Married Filing Separately",
    "year": 2025,
    "value": 15750
  },
  {
    "standardDeductionGroup": 1,
    "filingStatus": "Married Filing Separately",
    "year": 2025,
    "value": 17750
  },
  {
    "standardDeductionGroup": 2,
    "filingStatus": "Married Filing Separately",
    "year": 2025,
    "value": 19750
  },
  {
    "standardDeductionGroup": 3,
    "filingStatus": "Married Filing Separately",
    "year": 2025,
    "value": 21750
  },
  {
    "standardDeductionGroup": 4,
    "filingStatus": "Married Filing Separately",
    "year": 2025,
    "value": 23750
  },
  {
    "standardDeductionGroup": 0,
    "filingStatus": "Single Taxpayers",
    "year": 2025,
    "value": 15750
  },
  {
    "standardDeductionGroup": 1,
    "filingStatus": "Single Taxpayers",
    "year": 2025,
    "value": 17750
  },
  {
    "standardDeductionGroup": 2,
    "filingStatus": "Single Taxpayers",
    "year": 2025,
    "value": 19750
  },
  {
    "standardDeductionGroup": 0,
    "filingStatus": "Head of Household",
    "year": 2026,
    "value": 24150
  },
  {
    "standardDeductionGroup": 1,
    "filingStatus": "Head of Household",
    "year": 2026,
    "value": 26200
  },
  {
    "standardDeductionGroup": 2,
    "filingStatus": "Head of Household",
    "year": 2026,
    "value": 28250
  },
  {
    "standardDeductionGroup": 0,
    "filingStatus": "Married Filing Jointly",
    "year": 2026,
    "value": 32200
  },
  {
    "standardDeductionGroup": 1,
    "filingStatus": "Married Filing Jointly",
    "year": 2026,
    "value": 33850
  },
  {
    "standardDeductionGroup": 2,
    "filingStatus": "Married Filing Jointly",
    "year": 2026,
    "value": 35500
  },
  {
    "standardDeductionGroup": 3,
    "filingStatus": "Married Filing Jointly",
    "year": 2026,
    "value": 37150
  },
  {
    "standardDeductionGroup": 4,
    "filingStatus": "Married Filing Jointly",
    "year": 2026,
    "value": 38800
  },
  {
    "standardDeductionGroup": 0,
    "filingStatus": "Married Filing Separately",
    "year": 2026,
    "value": 16100
  },
  {
    "standardDeductionGroup": 1,
    "filingStatus": "Married Filing Separately",
    "year": 2026,
    "value": 18150
  },
  {
    "standardDeductionGroup": 2,
    "filingStatus": "Married Filing Separately",
    "year": 2026,
    "value": 20200
  },
  {
    "standardDeductionGroup": 3,
    "filingStatus": "Married Filing Separately",
    "year": 2026,
    "value": 22250
  },
  {
    "standardDeductionGroup": 4,
    "filingStatus": "Married Filing Separately",
    "year": 2026,
    "value": 24300
  },
  {
    "standardDeductionGroup": 0,
    "filingStatus": "Single Taxpayers",
    "year": 2026,
    "value": 16100
  },
  {
    "standardDeductionGroup": 1,
    "filingStatus": "Single Taxpayers",
    "year": 2026,
    "value": 18150
  },
  {
    "standardDeductionGroup": 2,
    "filingStatus": "Single Taxpayers",
    "year": 2026,
    "value": 20200
  }
]
